import React from 'react';
import '../less/double_salary.less';
import Banner from './../../../../auxiliary-components/shared/Banner';
import choose_winners_img from '../img/choose_winners_img.png';
import double_salary_banner_img from '../img/double_salary_banner_img.png';
import stages from '../enums/stages.json';
import prizes from '../enums/prizes.json';
import FilesForDownload from './../../../../auxiliary-components/shared/FilesForDownload';
import { pr_page_subscribe_instagram } from '../../../../services/urls/urls';

export default function template() {
    const isMobile = this.isViewportMobile();
    const bannerDatesBlock = (
      <div className='double-salary-block banner-dates'>{this.l10n('DOUBLE_SALARY_BANNER_DATES')}</div>
    );
    const stageBlocks = stages.map((el, idx) => (
      <div className="bottom-choose-winners__column" key={idx}>
        <div className="bottom-choose-winners__item">
          <div className="bottom-choose-winners__subtitle">{this.l10n(el.subtitle)}</div>
          <div className="bottom-choose-winners__text">{this.l10n(el.text)}</div>
        </div>
      </div>
    ));

    const filesForDownload = {
        data: [
            {
                title_ua: this.l10n('DOUBLE_SALARY_FILES_FOR_DOWNLOAD_TITLE'),
                name_ua: this.l10n('DOUBLE_SALARY_FILES_FOR_DOWNLOAD_NAME'),
                image_path: '/api/v1/media/img?path=PDF.png',
                link_path_ua: '/static/offers/double_salary_rules.pdf',
            },
        ],
    };

    return (
      <div className='double-salary'>
        <Banner
            text={'DOUBLE_SALARY_BANNER_SUBTITLE'}
            textMob={'DOUBLE_SALARY_BANNER_SUBTITLE'}
            title={'DOUBLE_SALARY_BANNER_TITLE'}
            page={'double_salary'}
            isMobile={isMobile}
            img={double_salary_banner_img}
            complDates
            dates={bannerDatesBlock}
        ></Banner>
        <div className='content'>
          <div className="prizes">
            <h2 className="prizes__title">{this.l10n('DOUBLE_SALARY_PRIZES_TITLE')}</h2>
            <div className="prizes__row">
              {prizes.map((item, index) => (
                <div className="prizes__item" key={index}>
                  <div className="prizes__subtitle">{this.l10n(item.title)}</div>
                  <div className="prizes__text">{this.l10n(item.text)}</div>
                </div>
              ))}
            </div>
            <div className="prizes__text">{this.l10n('DOUBLE_SALARY_PRIZES_TEXT')}</div>
          </div>
          <div className="choose-winners">
            <div className="choose-winners__top top-choose-winners">
              <h2 className="top-choose-winners__title">{this.l10n('DOUBLE_SALARY_TOP_CHOOSE_WINNERS_TITLE')}</h2>
              <div className="top-choose-winners__text">{this.l10n('DOUBLE_SALARY_TOP_CHOOSE_WINNERS_TEXT')}<a href={pr_page_subscribe_instagram} target='_blank' rel="noopener noreferrer">{this.l10n('DOUBLE_SALARY_TOP_CHOOSE_WINNERS_LINK')}</a></div>
            </div>
            <div className="choose-winners__bottom bottom-choose-winners">
              <h3 className="bottom-choose-winners__title">{this.l10n('DOUBLE_SALARY_BOTTOM_CHOOSE_WINNERS_TITLE')}</h3>
              <div className="bottom-choose-winners__body">
                <div className="bottom-choose-winners__left">
                  {stageBlocks}
                </div>
                <div className="bottom-choose-winners__right">
                  <img src={choose_winners_img} alt="choose winners img" />
                </div>
              </div>
            </div>
          </div>
          <FilesForDownload widget={filesForDownload}/>
        </div>
      </div>
    );
}
